import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect, PageNotFound, Provider} from 'gwx-voyager-components';
import configureStore from '../redux/configureStore';
import App from '../App/App.react';
import LandingPage from '../LandingPage/LandingPage.react';
import Profile from '../Profile/Profile.react';
import ClaimPage from '../Invitation/ClaimPage.react';
import InvitationListContainer from '../Invitation/List/InvitationList.react';

const store = configureStore();

const Root = () => (
	<Provider store={store}>
		<Router>
			<Switch>
				<Route path='/pageNotFound' component={PageNotFound} />
				<Route path='/claim' component={InvitationListContainer} />
				<Route exact path='/' render={() => <Redirect to='/communities' />} />
				<Route exact path='/communities' component={LandingPage} />
				<Route exact path='/profile/:profileId' component={Profile} />
				<Route exact path='/:communityId/claim/:invitationId' component={ClaimPage} />
				<Route path='/:id' component={App} />
			</Switch>
		</Router>
	</Provider>
);

export default Root;
